import { Component, OnInit, OnDestroy, ChangeDetectorRef, ViewChild } from '@angular/core';
import { debounceTime, takeUntil, filter, take } from 'rxjs/operators';
import { Subject, BehaviorSubject, combineLatest } from 'rxjs';
import { UsersService, CompanyService, AuthService } from 'app/services';
import { User, Profile, Company } from 'app/models';
import { Router } from '@angular/router';
import { CompanySearchService } from 'app/services/company-search.service/company-search.service';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { SelectionModel } from '@angular/cdk/collections';
import { environment } from 'environments/environment';

@Component({
  standalone: false,
  selector: 'app-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.scss']
})
export class CompanyComponent implements OnInit, OnDestroy {
  displayedColumns = [
    'name',
    'address',
    'sectorNumber',
    'location'
  ];
  users: User[];
  newUsers: User[];
  loading: boolean;
  user: User;
  error: string;
  queryString: string;
  private onDestroy$ = new Subject<void>();
  private searchValSubject = new BehaviorSubject<string>('');
  searchVal$ = this.searchValSubject.asObservable();
  currentPageCompanies: Company[];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  companiesDataSource =  new MatTableDataSource([]);
  selection = new SelectionModel<Profile>(true, []);
  searching = false;
  companies: Company[];
  message = 'No_Companies_Found';
  noRecordFound: boolean;
  headerMessage: string;
  constructor(
    private _usersService: UsersService,
    private _router: Router,
    private changeDetect: ChangeDetectorRef,
    public _companySearchService: CompanySearchService,
    private _companyService: CompanyService,
    private readonly _translateService: TranslateService,
    private readonly authService: AuthService
  ) {}

  ngOnInit() {
    this.getHeader();
    this.subscribeToUser();
    this.subscribeToCompanies();
    this.changeDetect.detectChanges();
    this.searchVal$
    .pipe(takeUntil(this.onDestroy$), debounceTime(250))
    .subscribe(res => {
        if (res !== '' && res != null && res.trim().length >= Number(environment.minimumSearchLength)) {
          this._companySearchService._loading = true;
          this._companySearchService.searchCompanies(this.queryString);
        } else {
          this._companySearchService._loading = false;
          this.searching = false;
        }
      });
  }

  getHeader() {
    this._translateService
      .get('My_Recent_Companies')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(value => {
        this.headerMessage = value;
      });
  }
  subscribeToUser() {
    combineLatest([
      this.authService.user$,
      this._usersService.user$
    ])
      .pipe(
        takeUntil(this.onDestroy$),
        filter(([authUser, user]) => !!authUser && !!user),
        take(1)
      )
      .subscribe(([authUser, user]) => {
        this.user = user;
        if (authUser.isExternal && user.companyId) {
          this._router.navigate(['company', user.companyId]);
        }
      });
  }

  subscribeToCompanies(): void {
    this._companySearchService.companies$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(companies => {
        if (companies) {
          this.companies = this.shapeCompany(companies);
          this.companies = this._companySearchService.sortCompanySearch(this.companies)

          this.noRecordFound = companies.length === 0;
        } else {
          this.companies = companies;
          this.noRecordFound = true;
        }
        this.companiesDataSource.data = this.companies;
        this.companiesDataSource.paginator = this.paginator;
        this.companiesDataSource
            .connect()
            .pipe(takeUntil(this.onDestroy$))
            .subscribe((companiesList) => {
              this.currentPageCompanies = companiesList;
            });
        this._companySearchService._loading = false;
        this.loading = false;
        this.changeDetect.detectChanges();
      });

    this._companySearchService.error$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(error => {
        this.loading = false;
        this.error = error;
        this.changeDetect.detectChanges();
      });
  }

  shapeCompany(companies: Company[]): any[] {
    return companies.map(company => ({
      companyId: company['companyId'],
      address: company['address'],
      sectorNumber: company['sectorNumber'],
      accountId: company['accountId'],
      name: company.name,
      location: `${company['city']} , ${company['state']}`,
      role: null,
      image: company['image']
    }));
  }

  selectedRecord(event) {
    this._companyService.setCompany(event);
    this._companySearchService.clearCompanies();
    this._router.navigate(['company', event.companyId]);
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
  }

  monitorSearch(search: string) {
    this.queryString = search.trim();
    this.error = '';
    this._companySearchService.clearCompanies();
    this.searchValSubject.next(search);
    this.searching = true;
    this.loading = true;
  }
}
